module.exports = __webpack_public_path__ + "static/media/cash.62d3aee9.jpg";